import React from 'react';
import { Icon } from '../../interfaces/Icon';

export const CloseIcon: Icon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24px" viewBox="0 0 150 150" {...props}>
      <rect
        x="-5.05249"
        y="137.485"
        width="201.578"
        height="24.8445"
        rx="12.4222"
        transform="rotate(-45 -5.05249 137.485)"
      />
      <rect
        x="137.485"
        y="155.052"
        width="201.578"
        height="24.8445"
        rx="12.4222"
        transform="rotate(-135 137.485 155.052)"
      />
    </svg>
  );
};

export default CloseIcon;
